/**
 * Soften Shopify's native cookie banner into SANCTALE language.
 * Admin still owns the source banner; we rewrite on render only.
 * In development, reinstate the bar when Shopify suppresses it after consent.
 */
(function () {
  var SHOPIFY_MENTION = /,?\s*(?:waaronder|including)\s+Shopify,?/gi;
  var DISMISS_KEY = 'sanctale_cookie_bar_dismissed';
  var resizeObserver = null;

  var COPY = {
    nl: {
      title: 'Cookies',
      bodyBefore: 'We gebruiken cookies om deze site rustig te verbeteren. Meer in ons ',
      bodyAfter: '.',
      manage: 'Voorkeuren',
      accept: 'Accepteren',
      decline: 'Afwijzen',
    },
    en: {
      title: 'Cookies',
      bodyBefore: 'We use cookies to quietly improve this site. More in our ',
      bodyAfter: '.',
      manage: 'Preferences',
      accept: 'Accept',
      decline: 'Decline',
    },
  };

  function locale() {
    // Gallery copy is English; keep the consent bar in the same voice.
    return 'en';
  }

  function isDevelopment() {
    try {
      if (window.Shopify && Shopify.designMode) return true;
      if (window.Shopify && Shopify.theme && Shopify.theme.role === 'development') {
        return true;
      }
    } catch (e) {}
    return location.hostname === '127.0.0.1' || location.hostname === 'localhost';
  }

  function cleanShopifyMentions(root) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(function (textNode) {
      var next = textNode.nodeValue
        .replace(SHOPIFY_MENTION, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/\s+,/g, ',')
        .replace(/\s+\./g, '.');

      if (next !== textNode.nodeValue) {
        textNode.nodeValue = next;
      }
    });
  }

  function setButtonLabel(button, label) {
    if (!button || !label) return;
    var span = button.querySelector('span');
    if (span) {
      span.textContent = label;
    } else {
      button.textContent = label;
    }
  }

  function syncCookieOffset() {
    var banner = document.querySelector('#shopify-pc__banner');
    var root = document.documentElement;
    var offset = 0;

    if (banner) {
      var styles = window.getComputedStyle(banner);
      if (styles.display !== 'none' && styles.visibility !== 'hidden') {
        offset = Math.ceil(banner.getBoundingClientRect().height);
      }
    }

    root.style.setProperty('--sanctale-cookie-bar-offset', offset + 'px');
    root.classList.toggle('has-sanctale-cookie-bar', offset > 0);
  }

  function watchBannerSize(banner) {
    if (!window.ResizeObserver) {
      syncCookieOffset();
      return;
    }

    if (resizeObserver) {
      resizeObserver.disconnect();
    }

    resizeObserver = new ResizeObserver(function () {
      syncCookieOffset();
    });

    if (banner) {
      resizeObserver.observe(banner);
    }

    syncCookieOffset();
  }

  function setTrackingConsent(accepted) {
    try {
      if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
        Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: accepted,
            marketing: accepted,
            preferences: accepted,
            sale_of_data: accepted,
          },
          function () {}
        );
      }
    } catch (e) {}
  }

  function dismissBanner(banner, accepted) {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch (e) {}
    setTrackingConsent(accepted);
    if (banner && banner.parentNode) {
      banner.parentNode.removeChild(banner);
    }
    syncCookieOffset();
  }

  function wireActions(banner) {
    var accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    var decline = banner.querySelector('#shopify-pc__banner__btn-decline');
    var manage = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');

    if (accept && !accept.dataset.sanctaleWired) {
      accept.dataset.sanctaleWired = 'true';
      accept.addEventListener('click', function (event) {
        if (banner.dataset.sanctaleSynthetic === 'true') {
          event.preventDefault();
          dismissBanner(banner, true);
          return;
        }
        window.requestAnimationFrame(syncCookieOffset);
      });
    }

    if (decline && !decline.dataset.sanctaleWired) {
      decline.dataset.sanctaleWired = 'true';
      decline.addEventListener('click', function (event) {
        if (banner.dataset.sanctaleSynthetic === 'true') {
          event.preventDefault();
          dismissBanner(banner, false);
          return;
        }
        window.requestAnimationFrame(syncCookieOffset);
      });
    }

    if (manage && !manage.dataset.sanctaleWired) {
      manage.dataset.sanctaleWired = 'true';
      manage.addEventListener('click', function (event) {
        if (banner.dataset.sanctaleSynthetic !== 'true') return;
        event.preventDefault();
        try {
          if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.showPreferences) {
            Shopify.customerPrivacy.showPreferences();
          }
        } catch (e) {}
      });
    }
  }

  function rewriteBanner(banner) {
    if (!banner || banner.dataset.sanctaleReady === 'true') return;

    var copy = COPY[locale()];
    var title = banner.querySelector('#shopify-pc__banner__body-title');
    var paragraph = banner.querySelector('.shopify-pc__banner__body p');
    var policy = banner.querySelector('#shopify-pc__banner__body-policy-link');

    if (title) {
      title.textContent = copy.title;
    }

    if (paragraph && policy) {
      var link = policy.cloneNode(true);
      if (locale() === 'en' && /privacy/i.test(link.textContent || '')) {
        link.textContent = 'Privacy Policy';
      }
      paragraph.replaceChildren();
      paragraph.appendChild(document.createTextNode(copy.bodyBefore));
      paragraph.appendChild(link);
      paragraph.appendChild(document.createTextNode(copy.bodyAfter));
    } else {
      cleanShopifyMentions(banner.querySelector('.shopify-pc__banner__body'));
    }

    setButtonLabel(banner.querySelector('#shopify-pc__banner__btn-manage-prefs'), copy.manage);
    setButtonLabel(banner.querySelector('#shopify-pc__banner__btn-accept'), copy.accept);
    setButtonLabel(banner.querySelector('#shopify-pc__banner__btn-decline'), copy.decline);

    wireActions(banner);
    banner.dataset.sanctaleReady = 'true';
  }

  function ensureBanner() {
    var existing = document.querySelector('#shopify-pc__banner');
    if (existing) {
      rewriteBanner(existing);
      return;
    }

    if (!isDevelopment()) return;

    try {
      if (sessionStorage.getItem(DISMISS_KEY) === '1') return;
    } catch (e) {}

    var policyHref = '/policies/privacy-policy';
    try {
      if (window.Shopify && Shopify.routes && Shopify.routes.root) {
        policyHref = Shopify.routes.root.replace(/\/?$/, '/') + 'policies/privacy-policy';
      }
    } catch (err) {}

    var section = document.createElement('section');
    section.id = 'shopify-pc__banner';
    section.className = 'shopify-pc__banner__dialog';
    section.setAttribute('role', 'alertdialog');
    section.setAttribute('aria-modal', 'false');
    section.setAttribute('aria-labelledby', 'shopify-pc__banner__body-title');
    section.dataset.sanctaleSynthetic = 'true';
    section.innerHTML =
      '<div class="shopify-pc__banner__wrapper">' +
      '<div class="shopify-pc__banner__body">' +
      '<h2 id="shopify-pc__banner__body-title">Cookies</h2>' +
      '<p>We use cookies to quietly improve this site. More in our ' +
      '<a id="shopify-pc__banner__body-policy-link" href="' +
      policyHref +
      '" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.</p>' +
      '</div>' +
      '<div class="shopify-pc__banner__btns shopify-pc__banner__btns-granular">' +
      '<button type="button" id="shopify-pc__banner__btn-manage-prefs" class="shopify-pc__banner__btn-manage-prefs">Preferences</button>' +
      '<button type="button" id="shopify-pc__banner__btn-accept" class="shopify-pc__banner__btn-accept">Accept</button>' +
      '<button type="button" id="shopify-pc__banner__btn-decline" class="shopify-pc__banner__btn-decline">Decline</button>' +
      '</div>' +
      '</div>';

    document.body.appendChild(section);
    rewriteBanner(section);
  }

  function sanitizePrefs() {
    cleanShopifyMentions(document.querySelector('#shopify-pc__prefs__dialog'));
    cleanShopifyMentions(document.querySelector('.shopify-pc__prefs__intro-main'));
  }

  function run() {
    ensureBanner();
    sanitizePrefs();
    watchBannerSize(document.querySelector('#shopify-pc__banner'));
  }

  function observe() {
    run();

    var observer = new MutationObserver(function () {
      run();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
